export default function authHeader(isJson:boolean) {
  const userStr = localStorage.getItem("user");
  let user = null;
  if (userStr){
    user = JSON.parse(userStr);
  }
  let response = {};
  if(isJson){
    response = {'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json'};
  }
  if (user && user.accessToken) {
    let accessToken = { 'x-access-token': user.accessToken };
    if(!isJson){
      return accessToken;
    }
    return Object.assign({}, accessToken, response);
  } else {
    let accessToken = { 'x-access-token': null };
    if(!isJson){
      return accessToken;
    }
    return Object.assign({}, accessToken, response);
  }
}